import React from 'react'

import Tysiav2NotificationAnimatedIcon from 'DesignSystem/Svgs/Tysiav2NotificationAnimatedIcon/react.js'
import View from './view.js'

export default function Logic({ ...props }) {
  return (
    <View>
      <Tysiav2NotificationAnimatedIcon {...props} />
    </View>
  )
}
